class VideoToggle extends HTMLElement {
  connectedCallback() {
    const video = this.querySelector("video") || this.closest("section")?.querySelector("video");
    if (!video) return;
    if (this.hasAttribute("data-autoplay")) {
      const mql = window.matchMedia("(prefers-reduced-motion: reduce)");
      const sync = () => {
        if (mql.matches) {
          video.pause();
        } else if (video.paused) {
          video.play();
        }
      };
      sync();
      mql.addEventListener("change", sync);
    }
    const poster = this.querySelector(
      "[data-poster-overlay]"
    );
    if (poster) {
      const showPoster = () => {
        poster.style.display = video.currentTime === 0 ? "" : "none";
      };
      video.addEventListener("playing", () => poster.style.display = "none");
      video.addEventListener("pause", showPoster);
      video.addEventListener("ended", showPoster);
    }
    const btn = this.querySelector("[data-video-toggle]");
    if (!btn) return;
    const playLabel = btn.getAttribute("aria-label") || "Play video";
    const pauseLabel = btn.dataset.pauseLabel || btn.getAttribute("aria-label") || "Pause video";
    const updateState = () => {
      const paused = video.paused;
      btn.setAttribute("aria-label", paused ? playLabel : pauseLabel);
      this.toggleAttribute("data-paused", paused);
    };
    btn.addEventListener("click", () => {
      if (video.paused) {
        video.play();
      } else {
        video.pause();
      }
    });
    video.addEventListener("play", updateState);
    video.addEventListener("pause", updateState);
    video.addEventListener("ended", updateState);
    updateState();
  }
}
if (!customElements.get("video-toggle")) {
  customElements.define("video-toggle", VideoToggle);
}
